// extracted by mini-css-extract-plugin
export default {"settingsModal":"styles_settingsModal__v7KWS","name_input":"styles_name_input__-AoDm","code_input":"styles_code_input__3DA3W","inputTitle":"styles_inputTitle__ImeB0"};